/**
 * These types are a stand in for the validation gpb messages for the belltower validation framework.
 * Any code that needs to mock backend validation should use these, if/when backend validation is added
 * (or not added) this file can be deleted.
 */
import { INPUT_NEGATIVE_MESSAGE, OVERNIGHT_STOP_LENGTH_MESSAGE, PIT_STOP_LENGTH_MESSAGE } from "../../UserVisibleStrings";

export interface ValidationIssue
{
    readonly field: string;
    readonly issue: string;
    readonly severity: "error" | "warning";
}

export interface ValidationIssues
{
    readonly issues: ReadonlyArray<ValidationIssue>;
}

export const validateLengthOfStay = ( params: { lengthOfStay: number, isPitStop: boolean, isAdvisory: boolean, dailyStartTime: Date, dailyFinalEndTime: Date } ): string | undefined =>
{
    const { lengthOfStay, isPitStop, isAdvisory, dailyStartTime, dailyFinalEndTime } = params;

    const dailyDrivingMinutes =
        ( dailyFinalEndTime.getTime() - dailyStartTime.getTime() ) / ( 1000 * 60 );

    // maximalPitStopLength ensures that the pit stop does not exceed the overnight stay
    // or drive time, which causes undefined behavior in the router when inserting
    // unplanned overnight stops.
    const maximalPitStopLength = Math.min(
        dailyDrivingMinutes,
        ( 24 * 60 ) - dailyDrivingMinutes
    );

    if ( lengthOfStay > maximalPitStopLength && isPitStop && !isAdvisory )
    {
        return PIT_STOP_LENGTH_MESSAGE;
    }

    if ( ( lengthOfStay > 60 || lengthOfStay === 0 ) && !isPitStop )
    {
        return OVERNIGHT_STOP_LENGTH_MESSAGE;
    }

    if ( lengthOfStay < 0 )
    {
        return INPUT_NEGATIVE_MESSAGE;
    }

    return undefined;
};
